"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchPattern = exports.matchPatternWithConfig = void 0;

var _config = require("./config");

var _getExampleUrls = require("./getExampleUrls");

var _toMatcherOrError = require("./toMatcherOrError");

const matchPatternWithConfig = options => pattern => {
  const combinedOptions = Object.assign(Object.assign({}, _config.defaultOptions), options);
  const val = (0, _toMatcherOrError.toMatchFnOrError)(pattern, combinedOptions);
  return val instanceof Error ? {
    valid: false,
    error: val,
    match: () => false,

    get examples() {
      return [];
    },

    pattern,
    config: combinedOptions
  } : {
    valid: true,
    match: val,

    get examples() {
      return (0, _getExampleUrls.getExampleUrls)(pattern, combinedOptions) // sanity check - examples should all match
      .filter(url => val(url)) // prevent example list from getting too long
      .slice(0, 100);
    },

    pattern,
    config: combinedOptions
  };
};

exports.matchPatternWithConfig = matchPatternWithConfig;
const matchPattern = matchPatternWithConfig({});
exports.matchPattern = matchPattern;